<template>
  <div>
    <div class="handle-box">
      <el-form ref="queryForm" :model="queryForm" label-position="right" label-width="120px" class="searchForm">
        <el-row>
          <el-col :span="24">
            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item label="用户账号" prop="emplid">
                  <el-input class="handle-input" v-model="queryForm.emplid" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户名称" prop="name">
                  <el-input class="handle-input" v-model="queryForm.name" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商编码" prop="supplierCode">
                  <el-input class="handle-input" v-model="queryForm.supplierCode" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商名称" prop="supplierName">
                  <el-input class="handle-input" v-model="queryForm.supplierName" clearable style="width:100%"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-collapse-transition>
            <el-col :span="24" v-if="isShow">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="手机" prop="phone">
                    <el-input class="handle-input" v-model="queryForm.phone" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="邮箱" prop="email">
                    <el-input class="handle-input" v-model="queryForm.email" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-collapse-transition>
        </el-row>
        <el-row type="flex" justify="center" align="middle">
          <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
          <el-button size="mini" @click="onReset" type="primary">重置</el-button>
          <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
        </el-row>
      </el-form>
    </div>
    <el-row class="action-btn-row">
      <el-button size="mini" class='btn' type="primary" @click="onAdd">新增</el-button>
      <el-button size="mini" class='btn' type="danger" @click="onDel">删除</el-button>
    </el-row>
    <el-table :data="dataList" @selection-change="handleSelectionChange" ref="dataList" border highlight-current-row>
      <el-table-column width="55px" type="selection" align="center"></el-table-column>
      <el-table-column label="用户账号" prop="emplid" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column label="用户名称" prop="name" show-overflow-tooltip min-width="160px"></el-table-column>
      <el-table-column label="供应商编码" prop="supplierCode" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column label="供应商名称" prop="supplierName" show-overflow-tooltip min-width="160px"></el-table-column>
      <el-table-column label="手机" prop="phone" show-overflow-tooltip min-width="100px"></el-table-column>
      <el-table-column label="邮箱" prop="email" show-overflow-tooltip min-width="200px"></el-table-column>
      <el-table-column label="操作" width="100px">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click="onDelItem(scope.row,scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryForm.pageNum" :page-sizes="pageSizeList" :page-size="queryForm.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="raterDialog1" append-to-body width="80%" title="选择用户" @close="closeRaterDialog">
      <pickRaterDialog v-if="raterDialog1" :emplidLists="emplidLists" @closeRaterDialog="closeRaterDialog"></pickRaterDialog>
    </el-dialog>
  </div>
</template>
<script>
import paginationMixin from '@/mixins/pagitionMixin';
import report from "@/api/sensory/processReport";
import pickRaterDialog from "./pickRaterDialog.vue";
export default {
  name: 'RaterDialog',
  mixins: [paginationMixin],
  components: { pickRaterDialog },
  data() {
    return {
      isShow: false,
      multipleSelection: [],
      queryForm: {
        emplid: "",
        name: "",
        supplierCode: "",
        supplierName: "",
        phone: "",
        email: "",
        pageSize: 15,
        pageNum: 1,
      },
      totalCount: 0,
      pages: 1,
      dataList: [],
      raterDialog1: false,
      emplidLists: null
    }
  },
  created() {
    this.queryData()
  },
  methods: {
    queryData() {
      report.querySensoryRaters(this.queryForm).then(res => {
        console.log("🚀 ~ querySensoryRaters ~ res:", res)
        if (res) {
          this.dataList = res.resultData
          this.totalCount = res.totalCount
        }
      })
    },
    closeRaterDialog() {
      this.emplidLists = null
      this.raterDialog1 = false
      this.queryData()
    },
    onAdd() {
      this.emplidLists = JSON.stringify(this.dataList.map(item => item.emplid))
      this.raterDialog1 = true
    },
    onDel() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请至少选择一条数据')
        return false
      }
      var ids = this.multipleSelection.map(item => item.ttSensorySupplierRaterId)
      console.log('ids :', ids);
      this.$confirm('是否确定删除选中的数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        report.delSensoryRaters(ids).then(resp => {
          console.log('delSensoryRaters~resp :', resp);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.queryData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    onDelItem(item, index) {
      this.$confirm('是否确定删除选中的数据?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        report.delSensoryRaters([item.ttSensorySupplierRaterId]).then(resp => {
          console.log('delSensoryRaters~resp :', resp);
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.queryData()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    handleSizeChange(val) {
      this.queryForm.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.queryForm.pageNum = val
      this.queryData()
    },
    onSearch() {
      this.queryForm.pageNum = 1;
      this.queryData()
    },
    onReset() {
      this.queryForm = {
        emplid: "",
        name: "",
        supplierCode: "",
        supplierName: "",
        phone: "",
        email: "",
        pageSize: 15,
        pageNum: 1,
      }
      this.queryData()
    },
  }
}
</script>
